import { createSlice } from '@reduxjs/toolkit';
// 安全地设置 localStorage 数据
const setStorageItem = (key, value) => {
    try {
        localStorage.setItem(key, value);
    }
    catch (error) {
        console.error(`Error setting localStorage for key "${key}":`, error);
    }
};
// 安全地删除 localStorage 数据
const removeStorageItem = (key) => {
    try {
        localStorage.removeItem(key);
    }
    catch (error) {
        console.error(`Error removing localStorage for key "${key}":`, error);
    }
};
// 安全地获取 localStorage 数据
const getStorageItem = (key) => {
    try {
        return localStorage.getItem(key);
    }
    catch (error) {
        console.error(`Error accessing localStorage for key "${key}":`, error);
        return null;
    }
};
const initialState = {
    user: null,
    token: getStorageItem('token'),
    refreshToken: getStorageItem('refreshToken'),
    isAuthenticated: !!getStorageItem('token'),
    isLoading: false,
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { user, token, refreshToken } = action.payload;
            state.user = user;
            state.token = token;
            state.refreshToken = refreshToken;
            state.isAuthenticated = true;
            // 保存到 localStorage
            setStorageItem('token', token);
            setStorageItem('refreshToken', refreshToken);
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        updateToken: (state, action) => {
            const { token, refreshToken } = action.payload;
            state.token = token;
            state.refreshToken = refreshToken;
            setStorageItem('token', token);
            setStorageItem('refreshToken', refreshToken);
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
            // 清除 localStorage
            removeStorageItem('token');
            removeStorageItem('refreshToken');
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    },
});
export const { setCredentials, setUser, updateToken, logout, setLoading } = authSlice.actions;
export default authSlice.reducer;
// Selectors
export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthToken = (state) => state.auth.token;
export const selectAuthLoading = (state) => state.auth.isLoading;
